// #1981: zoeken en filters van de Template Maker. Zoals het ledenoverzicht
// (leden_filters_controller): resultaten verversen terwijl je typt en zodra een
// filter wijzigt. Het formulier staat boven de lijst; "Rijen per pagina" staat
// in de lijst en hoort via form="tm_filters" bij hetzelfde formulier.
import { Controller } from "stimulus"
import { verstuurZonderLegeVelden } from "./leden_filters_controller"

export default class extends Controller {
  static targets = ["formulier"]

  disconnect() {
    clearTimeout(this.timer)
  }

  zoek() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.verstuur(), 300)
  }

  direct(event) {
    event.preventDefault()
    clearTimeout(this.timer)
    this.verstuur()
  }

  verstuur() {
    if (this.hasFormulierTarget) verstuurZonderLegeVelden(this.formulierTarget)
  }
}
